export default "__VITE_ASSET__DsuKBfLk__"